import { EPaymentInitSource, EProductType } from '../../types/redux/checkout';
import { IGetCheckoutDataResult, getCheckoutData } from '../../services/common/getCheckoutData';
import { setPaymentCheckoutState } from '../../actions/checkout';
import { TThunkAction } from '../../types/redux';
import { TPackageId } from '../../types/api';

interface IParams {
  price: number;
  productType: EProductType;
  paymentInitSource: EPaymentInitSource;
  transactionId: string | undefined;
  packageId: TPackageId;
}

export const loadCheckoutDataThunk =
  (params: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi }) => {
    const { price, productType, paymentInitSource, transactionId, packageId } = params;

    const { balance, totalAmount }: IGetCheckoutDataResult = await getCheckoutData({ httpApi, price });

    const isUseBalanceFundsVisible = balance > 0;

    const isUseBalanceFunds = isUseBalanceFundsVisible;

    const paymentAmount = (isUseBalanceFundsVisible && totalAmount) || price;

    dispatch(
      setPaymentCheckoutState({
        isUseBalanceFundsVisible,
        isUseBalanceFunds,
        price,
        balance,
        totalAmount,
        paymentAmount,
        productType,
        paymentInitSource,
        transactionId,
        packageId,
      }),
    );
  };
